import React from "react";
import { useLocation } from "react-router-dom";

import { useAppState } from "../../../context/StateContext";
import ReportMaintenance from "../../../pages/private/Moving/Report/Maintenance";
import Reports from "../../../pages/private/Shared/Report";
import ReportSPMaintenance from "../../../pages/private/Shared/Report/Maintenance/SupplyChain";
import { isMoving } from "../../../util/validation";

type ReportsOnly =
  | "favorites"
  | "management"
  | "finance"
  | "business"
  | "operations"
  | "warehousing";

const getOnlyFromLocation = (location: any): ReportsOnly | undefined => {
  const stateOnly = location?.state?.reportsFilter as ReportsOnly | undefined;
  if (stateOnly) return stateOnly;

  const params = new URLSearchParams(location?.search || "");
  const q = params.get("reports") as ReportsOnly | null;
  return q ?? undefined;
};

const ReportsWrapper = (props: any) => {
  const location = useLocation();
  const only = getOnlyFromLocation(location);

  return <Reports {...props} only={only} />;
};

const ReportsMaintenanceWrapper = (props: any) => {
  const { currentUser } = useAppState();
  return isMoving(currentUser?.company) ? (
    <ReportMaintenance {...props} />
  ) : (
    <ReportSPMaintenance {...props} />
  );
};

export { ReportsWrapper, ReportsMaintenanceWrapper };
